import React, { FC, useState } from 'react';
import { Input, Typography, Modal } from 'antd';
import { InfoCircleOutlined, MinusOutlined, PlusOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { HintTooltip } from '.';

interface ExpansionFormProps {
  label: string;
  disabled?: boolean;
  onClose?: () => void;
  defaultOpen?: boolean;
  tooltip?: string;
  [x: string]: any;
}

const ExpansionForm: FC<ExpansionFormProps> = (props) => {
  const { children, onClose, disabled, defaultOpen, label, tooltip, ...rest } = props;
  const [open, setOpen] = useState(defaultOpen);
  const [t] = useTranslation();

  const handleOpen = () => {
    if (open) {
      Modal.confirm({
        title: t('informationWillBeLost'),
        icon: <InfoCircleOutlined />,
        content: t('areYouSure'),
        okText: t('yes'),
        okType: 'primary',
        cancelText: t('no'),
        onOk() {
          setOpen(false);
          if (typeof onClose === 'function') {
            onClose();
          }
        },
      });
    } else {
      setOpen(true);
    }
  };

  return (
    <>
      <div style={bottomMargin}>
        <Typography.Link role="button" onClick={handleOpen} disabled={disabled}>
          {open ? <MinusOutlined /> : <PlusOutlined />}{' '}
          {(
            <>
              {label} {tooltip && <HintTooltip text={tooltip} />}
            </>
          ) || 'Open'}
        </Typography.Link>
      </div>
      {open && <Input.Group {...rest}>{children}</Input.Group>}
    </>
  );
};

const bottomMargin = { marginBottom: 8 };

export default ExpansionForm;
